<template>
  <section>
    <b-table :data="emailCaseLog" v-if="emailCaseLog.length">
      <template slot-scope="props">
        <b-table-column field="caseid" label="Case ID">
          <span>
            {{ props.row.caseid }}
          </span>
        </b-table-column>
        <b-table-column field="allocationtype" label="Allocation Type">
          <span>
            {{ props.row.allocationtype || '-'}}
          </span>
        </b-table-column>
        <b-table-column field="createdby" label="Created By">
          <span>
            {{ props.row.createdby }}
          </span>
        </b-table-column>
        <b-table-column field="createddate" label="Created Date">
          <span v-if="props.row.createddate">
            {{props.row.createddate |dateFiactiveComponentlter}}
          </span>
        </b-table-column>
        <b-table-column field="status" label="Email Status">
          <span class="is-capitalized tag is-warning is-fullwidth is-normal" :class="props.row.statusClass">
            {{ props.row.status }}
          </span>
        </b-table-column>
        <b-table-column field="comment" label="Comment">
          <span>
            {{ props.row.comment }}
          </span>
        </b-table-column>
        <b-table-column label="Email Preview">
          <span v-if="props.row.caseid && props.row.status && props.row.status.toLowerCase() ==='close'">
            <EmailPreview :setCaseID="[props.row.caseid]" :buttonType="'eye'"></EmailPreview>
          </span>
          <span v-else>-</span>
        </b-table-column>
      </template>
    </b-table>
    <div class="is-size-7 has-text-centered no_record" v-if="!emailCaseLog.length">
      <p class="content has-text-grey">
        <!--<b-icon icon="alert-decagram"></b-icon>--> &nbsp;
        <span class="is-size-6">No Records Found </span>
      </p>
    </div>
  </section>
</template>
<script>
//import CONSTANTS from '@/utils/constants'
import EmailPreview from './EmailPreview'
//import filters from '@/filters/filter'
//import stores from '@/stores'

export default {
  name: 'emailCaseLog',
  filters: {
    //dateFilter: filters.formatDate
  },
  components: {
    EmailPreview
  },
  props: ['caseid'],
  data: () => ({
    emailCaseLog: []
  }),
  created () {
    // do something after creating vue instance
    //this.getEmailCaseLog(this.caseid)
  },
  watch: {
    caseid: function () {
     // this.getEmailCaseLog(this.caseid)
    }
  },
  methods: {
    getEmailCaseLog: function (emailCaseID) {
      let object = {
        caseid: [emailCaseID]
      }
      return http.post(`${CONSTANTS.API_URL}/api/getemailcaselog`, object)
        .then((result) => {
          if (result && result.length) {
            let finalResult = stores.user.setStatusWiseCSS(result)
            this.emailCaseLog = finalResult
          }
        }).catch((httpException) => {
          this.$buefy.toast.open({
            message: httpException.message,
            type: 'is-danger'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/components/emailr/emailCaseLog.vue?717df19c